// React
import React from 'react';
// Styles
import './styles.scss';

/**
 * @param {string} props.title - The text to be display as title
 */
const PageTitle = (props) => (
    <div className="page-title">
        <h1>{props.title ? props.title : props.children}</h1>
    </div>
);

export default PageTitle;
